export function isDevEnabled() {
  return process.env.MODE === "individual" || process.env.MODE === "sandbox";
}
